import React from 'react'
import DoorSizeSelectorComponent from './doorSizeSelectorComponent'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Link } from '@material-ui/core/index'
import { doorSizeUpdate } from '../../../../helpers/restHelpers'
import { strings } from '../../../../localization/strings'
import Loader from '../../../loaders/dots_loader/index'
import { withRouter } from 'react-router-dom'

class Component extends React.Component {
    state = { open: false, sizeSelected: '', loading: false }

    handleClickOpen = () => {
        this.setState({ open: true })
    }

    handleClose = (force) => {
        if (force !== true) {
            if (this.state.loading) return
        }
        this.setState({ open: false, loading: false, sizeSelected: '' })
    }

    handleSizeSelect = (e) => {
        if (e === null) {
            this.handleClose(true)
        } else {
            this.setState({ sizeSelected: e })
        }
    }

    confirm = () => {
        this.setState({ loading: true })
        doorSizeUpdate({ orderId: this.props.order.id, doorSizeId: this.state.sizeSelected.id })
            .then(() => {
                this.handleClose(true)
                window.showDialog(
                    {
                        title: strings.doorSizeSelector_resultOkTitle,
                        message: strings.doorSizeSelector_resultOk,
                    },
                    () => this.props.actionDone()
                )
            })
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
    }

    render() {

        if (this.props.order.shippingMethodId !== 1 || this.props.order.orderStateId !== 1) return null;

        return (
            <div>
                <Link component="button" onClick={this.handleClickOpen}>{
                    !this.props.order.doorSizeName ?
                        strings.doorSizeSelector_button_null
                        : strings.doorSizeSelector_button + ' ' + this.props.order.doorSizeName
                } </Link>

                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {strings.doorSizeSelector_title}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            id="alert-dialog-description"
                            style={{ whiteSpace: 'pre-line' }}
                        >
                            {strings.doorSizeSelector_text}

                        </DialogContentText>

                        <DoorSizeSelectorComponent
                            orderId={this.props.order.id}
                            handleSizeSelect={this.handleSizeSelect}
                            doorSizeId={this.props.order.doorSizeId}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleClose}
                            color="primary"
                            disabled={this.state.loading}
                        >
                            {strings.close}
                        </Button>
                        <Button
                            onClick={this.confirm}
                            color="primary"
                            autoFocus
                            disabled={this.state.loading || !this.state.sizeSelected}
                        >
                            {strings.continue}
                        </Button>
                    </DialogActions>
                    {this.state.loading ? <Loader /> : null}
                </Dialog>
            </div>
        )
    }
}

export default withRouter(Component)
